module.exports = __webpack_public_path__ + "files/a32982a7cdeff77995ef5773fde7c3e0.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-4.png
// module id = 535
// module chunks = 76